export default __webpack_public_path__ + "static/media/amico.9d02fa4f.png";